export default "__VITE_ASSET__6819db31__"